import { useT } from "@repo/transifex";
import { ReportCard, ReportPriceRow } from "~/components/report";
import { useVatLabel } from "~/hooks/use-vat-label";

import { type PaymentSummaryData } from "./types";

type PaymentSummarySectionProps = {
  data: PaymentSummaryData;
};

export const PaymentSummarySection = ({ data }: PaymentSummarySectionProps) => {
  const t = useT();
  const { vatLabel } = useVatLabel();

  const visibleItems = data.items.filter((item) => item.amount !== 0);

  return (
    <ReportCard title={t("Payment Summary (incl. {vatLabel})", { vatLabel })}>
      {visibleItems.map((item) => (
        <ReportPriceRow
          key={item.label}
          label={item.label}
          value={item.amount}
          currency={data.currency}
        />
      ))}
      {visibleItems.length === 0 && (
        <ReportPriceRow
          label={t("No payments")}
          value={0}
          currency={data.currency}
        />
      )}
      <ReportPriceRow
        label={t("TOTAL")}
        value={data.total}
        currency={data.currency}
        variant="bold"
      />
    </ReportCard>
  );
};
